<template>
  <div id="aniversario">

    <header>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="logo">
              <!-- <img :src="logo" /> -->
            </div>
          </div>

          <div class="col-md-12">
            <div class="form">
              <h1>Você organiza a sua festa e seus presentes podem ajudar quem mais precisa em forma de doações.</h1>
              <span>Ao criar um evento com nossa ferramenta, seus convidados podem doar para a Organização Social que mais toca o seu coração e que foi escolhida por você.</span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div id="formAniversario" class="container" v-if="showForm">
      <div class="row">
        <div class="col-md-4">
          <h4>Dados do Evento</h4>
          <span>Complete com os dados do evento e do organizador.</span>
        </div>
        <div class="col-md-8">
          <div class="profile-data">

            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <label>E-mail do Responsável</label>
                  <input type="text" name="email" placeholder="Informe o seu e-mail" v-model="email"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <label>Nome do Evento</label>
                  <input type="text" name="title" placeholder="Informe um título para o seu Evento" v-model="title"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="input">
                <label>Data do Evento</label>
                <input type="text" v-mask="maskDate" name="date" placeholder="Informe a data de acontecimento do Evento" v-model="date"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <label>Horário do Evento</label>
                  <input type="text" v-mask="maskHour" name="hour" placeholder="Informe a hora em que o Evento irá iniciar" v-model="hour"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <label>Local</label>
                  <input type="text" name="local" placeholder="Informe o nome do local" v-model="local"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-sm">
                <div class="input">
                  <label>Endereço do Evento</label>
                  <input type="text" name="address" placeholder="Informe o endereço do local" v-model="address"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="textarea">
                  <label>Descreva seu Evento:</label>
                  <textarea name="description" placeholder="Informe uma descrição para o Evento" v-model="description"></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <label>ONG Beneficiada</label>
                  <select name="project" v-model="projectId">
                    <option value="">Selecione...</option>
                    <option v-for="p in projects" :value="p.ProjectId" :key="p.ProjectId">{{p.Info.title}}</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-4">
          <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{msg}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
            {{successMsg}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <button class="btn submit" v-on:click.stop.prevent="save()">Gerar Convite</button>
        </div>
      </div>
    </div>

    <div id="buttonInvite" class="container" v-if="!showForm && showInviteButton">
      <div class="row">
          <div class="form col-md-12">
            <div class="content">
              <h3>Seu convite foi criado!</h3>
              <span>Envie seu Convite do Bem para seus convidados através do Whatsapp.</span>
              <div class="buttons">
                <button @click="shareWhatsapp()" class="whatsapp">
                  <font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" /> Enviar Convites
                </button>

                <!-- <button @click="shareFacebook()" class="facebook">
                  <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /> Compartilhar no Facebook
                </button> -->
              </div>
            </div>
          </div>
        </div>
    </div>
    
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 description">
            <h2>Conheça alguns Projetos Sociais cadastrados em nossa plataforma!</h2>
            <p>Escolha um projeto que toca seu coração e transforme vidas Faça do seu evento um momento de transformação social.</p>
          </div>
        </div>

        <div class="row" v-if="featuredProjects">
          <div class="col-md-12">
            <carousel :perPage="perPage" :navigationEnabled="navigationEnabled" :paginationEnabled="paginationEnabled" :autoplay="autoPlay">

              <slide v-for="(p, k) in featuredProjects" :key="k" @click="openProject(p.slug)">
                <div class="image">
                  <img :src="p.Info.image" />
                </div>
                <span v-if="p.Categories[0] && p.Categories[0].name">{{p.Categories[0].name}}</span>
                <h3>{{p.Info.title}}</h3>
                <p>{{p.Info.shortDescription}}</p>
              </slide>

            </carousel>
          </div>
        </div>
      </div>

      <div class="base">
        <!-- <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="company">
                <p><b>Click2Giv Serviços Online Ltda.</b> - CNPJ 12.636.988/0001-12</p>
              </div>
              <div class="contact">
                <p><b>suporte@click2giv.com - (11) 98741-1000</b></p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import logo from '../../assets/images/logo_black.png';
import auth from '../../services/auth'
import Loading from '../includes/Loading'
import Functions from '../../utils/functions'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF, faWhatsapp} from '@fortawesome/fontawesome-free-brands'
import { API } from '../../services/api'
import { Carousel, Slide } from 'vue-carousel';
import {mask} from 'vue-the-mask'

export default {
  name: 'FormPartner',
  components: {
    Carousel,
    Slide,
    Loading,
    FontAwesomeIcon
  },
  props: ['user'],
  data () {
    return {
      logo: logo,
      loading: false,
      msg: "",
      showMsg: "",
      successMsg: "",
      showSuccessMsg: "",
      showForm: true,
      showInviteButton: false,
      projectId: null,
      projects: null,
      featuredProjects: null,
      email: null,
      title: null,
      date: null,
      hour: null,
      local: null,
      address: null,
      description: null,
      scrollPosition: 0,
      perPage: 4,
      navigationEnabled: true,
      paginationEnabled: true,
      autoPlay: false,
      maskDate: 'XX/XX/XXXX',
      maskHour: 'XX:XX'
    }
  },
  created(){
    this.loadProjects()
  },
  mounted(){
    if(window.innerWidth < 415){
      this.perPage = 1
      this.navigationEnabled = false
      this.paginationEnabled = false
      this.autoPlay = true
    }
    var inviteEmail = localStorage.getItem('inviteEmail');
    if(inviteEmail){
      this.email = inviteEmail;
    }
  },
  methods: {
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        var featuredProjects = this.projects.filter((e) => {
          return (e.isFeatured) && e.Categories[0].name;
        });
        featuredProjects = Functions.arrayShuffle(featuredProjects)
        featuredProjects.splice(8, featuredProjects.length - 8);
        this.featuredProjects = featuredProjects
      });
    },
    save(){
      this.loading = true;
      if(this.validate()){
        this.$http.post(API.Invite.create, {
          email: this.email,
          title: this.title,
          date: this.date,
          hour: this.hour,
          local: this.local,
          address: this.address,
          description: this.description,
          projectId: this.projectId
        }).then((response) => {
          if(response.body.success == true){
            this.showForm = false;
            this.showInviteButton = true;
            this.inviteId = response.body.InviteId;
            this.$scrollTo('#buttonInvite', 500);
          }else{
            this.msg = "Erro ao criar o convite.";
            this.showMsg = true;
          }
          this.loading = false;
        }, (error) => {
          console.log(error)
          this.msg = "Erro ao criar o convite.";
          this.showMsg = true;
          this.loading = false;
        });
      }else{
        this.loading = false;
      }
    },
    validate(){
      if(this.email == '' || this.email == null){
        this.showMessage("Insira o seu e-mail.");
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.showMessage("E-mail inválido. Insira um e-mail no formato correto.");
        return false;
      }
      if(this.title == '' || this.title == null){
        this.showMessage("Insira o nome do seu evento.");
        return false;
      }
      if(this.local == '' || this.local == null){
        this.showMessage("Insira um local para o evento.");
        return false;
      }
      if(this.address == '' || this.address == null){
        this.showMessage("Insira o endereço do evento.");
        return false;
      }
      if(!this.projectId){
        this.showMessage("Selecione um projeto para continuar.");
        return false;
      }
      return true;
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
    shareWhatsapp(){
      var url = "http://new.click2giv.com/aniversariodobem/" + this.inviteId;
      window.location.href = "whatsapp://send?text=" + url;
    },
    shareFacebook(){

    },
    openProject(slug){
      this.$router.push({path: '/project/' + slug});
    },
  },
}
</script>

<style lang="scss" scoped>
h1{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 44px;
  line-height: 45px;
  letter-spacing: -0.04em;
  color: #333;
}

h2{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 35px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #333;
}

h3{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 25px;
  line-height: 25px;
  letter-spacing: -0.01em;
  color: #333;
}

header{
  width: 100%;
  display: block;
  height: 800px;
  background: url('../../assets/images/bkg-top-aniversario.jpg') bottom center;

  .logo{
    margin-top: 50px;
  }

  .form{
    margin-top: 200px;
    span{
      font-family: Rubik;
      color: #333;
      margin-top: 10px;
      width: 80%;
      display: block;
    }
  }
}

#formAniversario{
  width: 100%;
  display: block;
  min-height: 1340px;
  padding-bottom: 100px;
  position: relative;

  .input{
    margin-top: 30px;
    width: 100%;
    height: 70px;
    background-color: #fff;
    border-radius: 10px;
    border: thin solid #ccc;
    position: relative;
    
    label{
      color: #00AE39;
      font-size: 14px;
      position: absolute;
      top: 5px;
      left: 10px;
      font-family: Rubik;
    }

    input{
      position: absolute;
      width: 90%;
      top: 25px;
      padding-bottom: 5px;
      padding-top: 5px;
      font-size: 16px;
      left: 10px;
      border: none;
      margin: none;
      color: #333;
      font-family: Rubik;

      &:focus{
        outline: none;
      }
    }

    select{
      border: none;
      width: 95%;
      display: block;
      position: absolute;
      top: 20px;
      left: 20px;
      height: 40px;
      background-color: #fff;

      &:focus{
        outline: none;
      }
    }

  }

  .textarea{
    margin-top: 30px;
    width: 100%;
    height: 140px;
    background-color: #fff;
    border-radius: 10px;
    border: thin solid #ccc;
    position: relative;
    
    label{
      color: #00AE39;
      font-size: 14px;
      position: absolute;
      top: 5px;
      left: 10px;
      font-family: Rubik;
    }

    textarea{
      position: absolute;
      width: 95%;
      top: 25px;
      height: 110px;
      padding-bottom: 5px;
      padding-top: 5px;
      font-size: 16px;
      left: 10px;
      border: none;
      margin: none;
      color: #333;
      font-family: Rubik;
      resize: none;

      &:focus{
        outline: none;
      }
    }
  }

  .submit{
    color: #fff;
    background-color: #FB101F;
    border: none;
    border-radius: 10px;
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
    font-family: Rubik;
    float: right;
  }
}

#buttonInvite{
  width: 100%;
  display: block;
  min-height: 800px;
  padding-bottom: 100px;
  position: relative;

  .form{
    margin-top: 40px;
    background-color: #F2F7F5;
    padding: 50px;
    text-align: center;
    border-radius: 20px;
    border: 1px dashed #00AE39;
    box-sizing: border-box;

    .content{
      max-width: 600px;
      margin: 0 auto;

      span{
        font-family: Rubik;
        margin-top: 10px;
        display: block;
      }
    }

    .buttons{

      button{
        padding: 20px;
        border-radius: 20px;
        margin-top: 20px;
        font-size: 20px;
        cursor: pointer;
        border: thin solid #ccc;
      }
      .whatsapp{
        color: #25D366;
      }

      .facebook{
        color: #3C5A99;
      }
    }
  }
}

footer{
  width: 100%;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  height: 690px;
  background-color: #F2F7F5;
  border-top: 1px dashed #00AE39;

  .description{
    margin-top: 50px;
  }

  .VueCarousel-slide{
    height: 400px;
    padding-right: 20px;

    .image{
      width: 100%;
      height: 130px;
      border-radius: 10px;
      overflow: hidden;

      img{
        width: 100%;
      }
    }

    h3{
      font-size: 20px;
    }

    span{
      color: #00AE39;
      font-size: 14px;
      font-family: Rubik;
      margin-top: 10px;
      display: block;
    }

    p{
      font-family: Rubik;
      font-size: 14px;
      display: block;
      margin-top: 10px;
    }
  }

  .base{
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-top: 1px dashed #00AE39;
    position: absolute;
    bottom: 0;

    .company{
      float: left;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }

      b{
        font-weight: bold;
      }
    }

    .contact{
      float: right;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }
    }
  }
}

@media screen and (max-width: 414px) {

  header{
    height: 700px;
    background-position: left bottom;

    .logo{
      text-align: center;
    }

    .form{
      margin-top: 80px;
      text-align: center;

      h1{
        font-size: 26px;
      }

      span{
        width: 100%;
      }
      form{
        .input{
          width: 100%;

          button{
            right: 0px;
            font-size: 14px;
          }
        }
      }
    }
  }

  #formAniversario{
    margin-top: 50px;
    padding-bottom: 400px;

    .intro{
      .content{
        text-align: center;
      }
    }

    .profile-data{
      select{
        width: 90%;
      }
    }

    .btn{
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .form{
      .input{
          width: 100%;

        button{
          right: 0px;
          font-size: 14px;
        }
      }
    }
  }

  footer{
    height: 740px;
    .VueCarousel-slide{
      padding: 20px;
    }

    .description{
      text-align: center;
    }

    .base{
      height: auto;

      .company, .contact{
        float: none;
        text-align: center;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/aniversariodobem/AniversarioForm.vue